// noAuth-header.js
import StorageService from '../app/storage.service';

export default function apiHeader() {
    const appKey = process.env.NEXT_PUBLIC_APP_KEY;
    let domainType = '';
    let domain = '';

    if (typeof window !== 'undefined') {
        domainType = StorageService.get('domain-type');
        domain = StorageService.get('domain');
    }

    // Optional: validate domainType before using
    if (!domainType || !domain) {
        // console.warn('Missing domainType or domain in apiHeader');
        return {
            'app-key': `${appKey}`,
        };
    } else if (appKey && domainType && domain) {
        return {
            'X-Domain-Id': domain,
            'X-Domain-Type': domainType,
            'app-key': `${appKey}`,
        };
    } else {
        return {};
    }
}

export function getApiLink(suffixLink) {
    const prefixLink = process.env.NEXT_PUBLIC_API_URL;

    return prefixLink + suffixLink;
}
